import { useQuery } from '@tanstack/react-query';
import { LocationService } from '@/services/location.service';
import { LocationData } from '@/types/location.types';
import { logger } from '@/utils/logger';
import { defaultQueryOptions } from '@/config/react-query.config';

interface UseLocationsReturn {
  locations: LocationData[];
  isLoading: boolean;
  error: any;
  refetch: () => void;
}

/**
 * Hook to fetch all member locations
 * @param state Optional state filter
 */
export const useLocations = (state?: string): UseLocationsReturn => {
  const { data, isLoading, error, refetch } = useQuery<LocationData[], Error>({
    queryKey: ['locations', state] as const,
    queryFn: () => LocationService.getLocations(state),
    ...defaultQueryOptions,
  });

  // Log errors
  if (error) {
    logger.error('Failed to fetch locations:', error);
  }

  return {
    locations: (data as LocationData[]) ?? [],
    isLoading,
    error,
    refetch,
  };
};

export default useLocations;
